// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"input_wrapper__3JWQe","error":"input_error__uRqkb","correct":"input_correct__atJVc"};